module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bbf018f66a2d2b8c058dd17bf19930fd.png";